import {
    Avatar,
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    Radio,
    Skeleton,
    TextField,
    Theme,
    Typography,
    useTheme
} from "@mui/material";
import {
    useEffect,
    useState
} from "react";
import {
    useDispatch,
    useSelector
} from "react-redux";
import BreadCrum from "../../../../lib/BreadCrum";
import { RootStateType } from "../../../../redux-store/reducers";
import { useHistory } from "react-router";
import {
    checkImageExists,
    isModuleAllowed
} from "../../../../utils/utilityFunctions";
import {
    EmailIcon,
    FailureIcon,
    Phoneicon
} from "../../../../assets/SvgIcons";
import {
    ConfirmationDialog,
    ErrorDialog,
    SuccessDialog
} from "./CommonDialogs";
import {
    cancelSipTransaction,
    getIndividualFundDetails,
    getReasonsForSipCancellation,
    renewedCancelSipTransaction,
    renewedCancelStpTransaction,
    setAppliedSystematicPlansFilters,
    setSystematicPlansSearchText
} from "../../../../redux-store/actions/investorProfile";
import { getInvestmentUserDetails } from "../../../../redux-store/actions/funds";
import { GetInvestmentUserDetails } from "../../../../redux-store/types/api-types";
import { applicantStatusMasters, MPOWER_ACCOUNT_TYPE_MASTER, USER_ROLES } from "../../../../utils/constant";
import {
    CancelSipTransactionResponseBody,
    CancelStpTransactionResponseBody,
    GetIndividualFundDetailsResponseBody
} from "../../../../redux-store/types/investorProfile";
import { GenerateOtpResponseBody } from "../../../../redux-store/types/cart";
import { generateOtp } from "../../../../redux-store/actions/cart";
import { showError } from "../../../../redux-store/actions/auth";
import * as Yup from 'yup';
import { Form, Formik } from "../../../../lib/formik/Formik";
import { LoadingButton } from "@mui/lab";
import TransactionsDocumentUpload from "../../../../lib/TransactionsDocumentUpload";
import { getAbbreviatedName } from "../../../commonComponents";
interface ReasonObj {
    code: string;
    description: string;
    othersReasonText?: string
}

interface InitialValues {
    documents?: { documentId: string; documentType: string }[];
}

const validationSchema = (role: string, selectedPortfolioObj: Record<string, any>) => Yup.object().shape({
    ...(
        ![USER_ROLES.INVESTOR].includes(role as USER_ROLES) &&
        MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
        MPOWER_ACCOUNT_TYPE_MASTER["POA"]
    ) ? {
        documents: Yup.array().of(
            Yup.object().shape({
                documentId: Yup.string(),
                documentType: Yup.string()
            })
        )
    } : {}

    // handle validation for documents
})

function SeparatorCircle(): JSX.Element {
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            <Typography
                sx={(theme: Theme) => ({
                    width: "3px",
                    height: "3px",
                    backgroundColor: theme.palette.text.secondary,
                    borderRadius: "50%",
                    display: 'block',
                })}
            />
        </Box>
    )
}

const amcIds = ['BDOTR', 'BPIAMC']

export default function ReasonForCancellation(): JSX.Element {
    const dispatch = useDispatch()
    const { palette } = useTheme();
    const history = useHistory();
    const {
        pathname: pathName,
        state: routerStateObj
    } = history.location as {
        pathname: string,
        state: {
            clientCode: string;
            selectedPlanObj: { [key: string]: any };
            currentType: string
        }
    }

    const [reasonsList, setReasonsList] = useState<ReasonObj[]>([])
    const [isReasonsListLoading, setReasonsListLoading] = useState<boolean>(false)
    const [selectedReasonObj, setSelectedReasonObj] = useState<ReasonObj>({} as ReasonObj)
    const [userDetails, setUserDetails] = useState<{
        name: string;
        status: string;
        mobile: string;
        email: string;
        accountType: string;
        applicationType: string;
        modeOfHolding: string;
        investorType: string;
        isFamilyHead: string;
    }>({
        name: "",
        status: "",
        mobile: "",
        email: "",
        accountType: "",
        applicationType: "",
        modeOfHolding: "",
        investorType: "",
        isFamilyHead: ""
    })
    const [isUserDetailsLoading, setUserDetailsLoading] = useState<boolean>(false)
    const [isConfirmationDialogOpen, setConfirmationDialogOpen] = useState<boolean>(false)
    const [isSuccessDialogOpen, setSuccessDialogOpen] = useState<boolean>(false)
    const [isErrorDialogOpen, setErrorDialogOpen] = useState<boolean>(false)
    const [cancelResponse, setCancelResponse] = useState<{ [key: string]: any }>({})
    const [isCancelResponseLoading, setCancelResponseLoading] = useState<boolean>(false)
    const [otpLoading, setOtpLoading] = useState<boolean>(false);
    const [otpDetails, setOtpDetails] = useState<GenerateOtpResponseBody>({} as GenerateOtpResponseBody);
    const [planDetails, setPlanDetails] = useState<{
        amcId: string;
        planName: string;
        fundCategory: string;
        fundTypeCategory: string;
        riskType: string;
    }>({
        amcId: "",
        planName: "",
        fundCategory: "",
        fundTypeCategory: "",
        riskType: ""
    })
    const [isPlanDetailsLoading, setPlanDetailsLoading] = useState<boolean>(false);
    const [isDocumentUploadDialogVisible, setDocumentUploadDialogVisible] = useState<boolean>(false);
    const [isDocumentUploadErrorDialogVisible, setDocumentUploadErrorDialogVisible] = useState<boolean>(false);
    const [formikValues, setFormikValues] = useState<{ [key: string]: any }>({})

    const {
        role = '',
        permissions = []
    } = useSelector((store: RootStateType) => store.auth);
    const { selectedPortfolio = { label: '', value: '' }, selectedPortfolioObj } = useSelector((state: RootStateType) => state.selectedPortfiolio)
    const {
        iwappRmId = "",
        investorClientId = ""
    } = useSelector((store: RootStateType) => store.id);
    const { investorRmId = "" } = useSelector((store: RootStateType) => store.sessionData);

    const initialValues: InitialValues = {
        ...((
            ![USER_ROLES.INVESTOR].includes(role) &&
            MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
            MPOWER_ACCOUNT_TYPE_MASTER["POA"]
        ) ? {
            documents: [{
                documentId: "",
                documentType: ""
            }]
        } : {}
        )
    }

    const initialRouter = pathName.split('/').filter((item) => item !== '')

    const rmRouterPath = (isModuleAllowed({ value: "MFDashboard", compareArr: permissions, objKey: "permissonCode" }) ? [
        {
            name: 'Dashboard',
            path: '/dashboard',
        },
        {
            name: initialRouter[1] + `${selectedPortfolio.label ? `(${selectedPortfolio.label})` : ''}`,
            path: `/${initialRouter[0]}/${initialRouter[1]}`,
            state: {
                clientCode: routerStateObj?.clientCode ?? ""
            }
        },
        {
            name: 'Mutual Funds',
            path: `/${initialRouter[0]}/${initialRouter[1]}/${initialRouter[2]}`,
            state: {
                clientCode: routerStateObj?.clientCode ?? "",
            },
            search: `?tab=Systematic Plans&type=${routerStateObj?.currentType ?? "SIP"}`
        },
        {
            name: `Systematic Plans (${routerStateObj?.currentType?.toUpperCase() ?? "SIP"}) - Reason for cancellation`,
            path: `/${initialRouter[0]}/${initialRouter[1]}/${initialRouter[2]}/${initialRouter[3]}`,
            state: {
                clientCode: routerStateObj?.clientCode ?? ""
            },
            isTextLowerCase: false
        }
    ] : [])

    const investorRouterPath = [
        {
            name: 'Dashboard' + `${selectedPortfolio.label ? `(${selectedPortfolio.label})` : ''}`,
            path: '/investor-dashboard',
        },
        {
            name: 'Mutual Funds',
            path: `/${initialRouter[0]}/${initialRouter[1]}`,
            state: {
                clientCode: routerStateObj?.clientCode ?? "",
            },
            search: `?tab=Systematic Plans&type=${routerStateObj?.currentType ?? "SIP"}`
        },
        {
            name: `Systematic Plans (${routerStateObj?.currentType?.toUpperCase() ?? "SIP"}) - Reason for cancellation`,
            path: `/${initialRouter[0]}/${initialRouter[1]}/${initialRouter[2]}/${initialRouter[3]}`,
            state: {
                clientCode: routerStateObj?.clientCode ?? ""
            },
            isTextLowerCase: false
        }
    ]

    const fetchReasonsForCancellation = async () => {
        try {
            setReasonsListLoading(true)

            const response = await (dispatch(getReasonsForSipCancellation()) as unknown as Promise<{
                code: string;
                description: string;
            }[]>)
            setReasonsList(response ?? [])
        } catch (error) {
            console.log((error as Error)?.message);
        } finally {
            setReasonsListLoading(false)
        }
    }

    const fetchUserDetails = async () => {
        try {
            setUserDetailsLoading(true)

            const response = await (dispatch(getInvestmentUserDetails({
                clientCode: ![USER_ROLES.INVESTOR].includes(role) ? routerStateObj?.clientCode ?? "" : investorClientId,
                portfolioId: selectedPortfolio?.value ?? ""
            })) as unknown as Promise<GetInvestmentUserDetails>)

            setUserDetails({
                name: response?.name ?? "",
                status: response?.status ?? "",
                mobile: response?.mobile ?? "",
                email: response?.email ?? "",
                accountType: response?.accountType ?? "",
                applicationType: response?.applicationType ?? "",
                modeOfHolding: response?.modeOfHolding ?? "",
                investorType: response?.investorType ?? "",
                isFamilyHead: response?.isFamilyHead ?? ""
            })

        } catch (error) {
            console.log((error as Error)?.message);
        } finally {
            setUserDetailsLoading(false)
        }
    }

    const fetchPlanDetails = async () => {
        try {
            // setPlanDetailsLoading(true)

            // const response = await (dispatch(getIndividualFundDetails({
            //     schemeId: routerStateObj?.selectedPlanObj?.scheme,
            // })) as unknown as Promise<GetIndividualFundDetailsResponseBody>);

            setPlanDetails({
                amcId: routerStateObj?.selectedPlanObj?.amcId ?? "",
                planName: routerStateObj?.selectedPlanObj?.schemeName ?? "",
                fundCategory: routerStateObj?.selectedPlanObj?.fundCategory ?? "",
                fundTypeCategory: routerStateObj?.selectedPlanObj?.fundTypeCategory ?? "",
                riskType: routerStateObj?.selectedPlanObj?.riskType ?? ""
            })
        } catch (error) {
            console.log((error as Error)?.message);
        } finally {
            setPlanDetailsLoading(false)
        }
    }

    useEffect(() => {
        const fetchData = async () => {
            await Promise.allSettled([
                fetchReasonsForCancellation(),
                fetchUserDetails(),
                fetchPlanDetails()
            ])
        }

        fetchData()
    }, [])

    const handleReasonChange = (code: string) => {
        const reasonObj = reasonsList?.find(obj => obj?.code === code)

        if (reasonObj) {
            setSelectedReasonObj((
                (reasonObj?.code === "13" && reasonObj?.description?.toLowerCase()?.includes("others")) ?
                    { ...reasonObj, othersReasonText: "" } :
                    reasonObj
            ));
        } else {
            setSelectedReasonObj({} as ReasonObj)
        }
    };

    const handleOthersReasonChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSelectedReasonObj(prevState => ({
            ...prevState,
            othersReasonText: event.target.value
        }))
    }

    const handleCancelSipBtn = (values: InitialValues) => {
        if (Object.keys(selectedReasonObj).length === 0 && !['STP', 'SWP'].includes(routerStateObj?.currentType?.toUpperCase())) {
            dispatch(showError("Please select one reason to proceed!"))
            return;
        }
        else if (Object.keys(selectedReasonObj).length > 0 && selectedReasonObj?.code === "13" && selectedReasonObj?.othersReasonText?.length === 0) {
            dispatch(showError(`You have selected OTHERS, please specify the reason`))
            return;
        }
        else if ((
            ![USER_ROLES.INVESTOR].includes(role) &&
            MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
            MPOWER_ACCOUNT_TYPE_MASTER["POA"]
        )) {
            if (values?.documents?.length === 1 && (values?.documents[0]?.documentId === '' || values?.documents[0]?.documentType === '')) {
                setDocumentUploadErrorDialogVisible(true)
                return;
            }
        }
        setFormikValues(values);
        setConfirmationDialogOpen(true)
    }

    const validateSelectedReasonObj = (reasonObj: ReasonObj) => {
        if (reasonObj && Object.keys(reasonObj)?.length > 0) {
            if ("othersReasonText" in reasonObj) {
                if (reasonObj?.othersReasonText && reasonObj?.othersReasonText?.trim() !== '') {
                    return true;
                } else {
                    return false;
                }
            }
            return true
        }
        return false
    }

    const handleCancelBtnConfirmationDialog = () => {
        setConfirmationDialogOpen(false)
    }

    const handleOtpCase = async (cartId: string, token: string) => {
        const payload = {
            order_cart_id: cartId,
            token
        }
        try {
            setOtpLoading(true);
            const response = await (dispatch(generateOtp(payload)) as unknown as Promise<GenerateOtpResponseBody>)
            setOtpDetails(response);
            if (!response?.isSuccess) return;
            history.push(`${pathName}/cancel-otp-screen`, {
                paymentId: response?.token ?? "",
                cartId: response?.cartId ?? '',
                id: response?.id ? `${response?.id}` : "",
                message: response?.message ?? "",
            })
        } catch (e) {
            console.log('error', e);
            dispatch(showError(otpDetails?.message ?? ''))
        } finally {
            setOtpLoading(false);
        }
    }
    const handleConfirmBtnConfirmationDialog = async () => {
        try {
            setCancelResponseLoading(true)

            const payload = {
                clientCode: ![USER_ROLES.INVESTOR].includes(role) ? routerStateObj?.clientCode ?? "" : investorClientId,
                accountType: MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()],
                orderDetails: [
                    {
                        clientCode: ![USER_ROLES.INVESTOR].includes(role) ? routerStateObj?.clientCode ?? "" : investorClientId,
                        registrationNumber: routerStateObj?.selectedPlanObj?.registrationNo,
                        bseCancellationCode: selectedReasonObj?.code,
                        remarks: selectedReasonObj?.code === "13" ? (selectedReasonObj?.othersReasonText ?? "") : "",
                        rmId: `${iwappRmId}`,
                        portfolioId: selectedPortfolio?.value,
                        amcId: routerStateObj?.selectedPlanObj?.amcId,
                        fromSchemeName: routerStateObj?.selectedPlanObj?.schemeName,
                        fromSchemeCode: routerStateObj?.selectedPlanObj?.scheme,
                        isRecommended: ![USER_ROLES.INVESTOR].includes(role),
                        isDiy: [USER_ROLES.INVESTOR].includes(role),
                        folioNo: routerStateObj?.selectedPlanObj?.folioNo,
                        portfolioName: selectedPortfolio?.label
                    }
                ],
                ...(![USER_ROLES.INVESTOR].includes(role) &&
                    MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                    MPOWER_ACCOUNT_TYPE_MASTER["POA"]
                    ? {
                        documents: formikValues.documents?.map((doc: { documentId: string; documentType: string }) => ({
                            documentId: doc?.documentId,
                            documentType: doc?.documentType
                        }))
                    }
                    :
                    {}
                )
            }

            let response = {} as CancelSipTransactionResponseBody | CancelStpTransactionResponseBody;
            if (routerStateObj?.currentType?.toUpperCase() === 'SIP') {
                response = await (dispatch(renewedCancelSipTransaction(payload)) as unknown as Promise<CancelSipTransactionResponseBody>)
            }

            else if (routerStateObj?.currentType?.toUpperCase() === 'STP') {
                response = await (dispatch(renewedCancelStpTransaction({
                    ...payload,
                    orderDetails: payload.orderDetails.map(order => ({
                        ...order,
                        toSchemeName: routerStateObj?.selectedPlanObj?.schemeName ?? '',
                        toSchemeCode: routerStateObj?.selectedPlanObj?.toScheme ?? ''
                    }))
                }) as unknown as Promise<CancelStpTransactionResponseBody>
                ))
            }

            if (!response) {
                setConfirmationDialogOpen(false)
            }
            if (response?.isSuccess && response?.isPaymentFlow) {
                setCancelResponse(response)
                // handleOtpCase(response?.cartId ?? "", response?.token ?? "")
                if (response?.otp_response?.isSuccess) {
                    history.push(`${pathName}/cancel-otp-screen`, {
                        paymentId: response?.token ?? "",
                        cartId: response?.cartId ?? "",
                        id: response?.otp_response?.id ?? "",
                        message: response?.otp_response?.message ?? "",
                    })
                } else if (!response?.otp_response?.isSuccess) {
                    dispatch(showError(response?.otp_response?.message ?? ""))
                }
            }
            if (response.isSuccess && !response.isPaymentFlow) {
                setCancelResponse(response)

                setConfirmationDialogOpen(false)
                setSuccessDialogOpen(true)
            }
            if (!response.isSuccess) {
                setCancelResponse(response)

                setConfirmationDialogOpen(false)
                setErrorDialogOpen(true)
            }
        } catch (error) {
            console.log((error as Error)?.message);
        } finally {
            setCancelResponseLoading(false)
        }
    }



    const handleBtnSuccessDialog = () => {
        if (![USER_ROLES.INVESTOR].includes(role)) {
            history.push('/dashboard')
        } else {
            history.push('/investor-dashboard')
        }

        setSuccessDialogOpen(false)

        dispatch(setSystematicPlansSearchText(""))
        dispatch(setAppliedSystematicPlansFilters([]))
    }

    const handleBtnErrorDialog = () => {
        setErrorDialogOpen(false)
    }

    const handleDocumentUploadDialogOpen = () => {
        setDocumentUploadDialogVisible(true)
    }

    const handleDocumentUploadDialogClose = () => {
        setDocumentUploadDialogVisible(false)
    }

    const handleDocumentUploadErrorDialogClose = () => {
        setDocumentUploadErrorDialogVisible(false)
    }

    console.log('selected', selectedReasonObj);

    const checkAmcId = amcIds.includes(planDetails?.amcId ?? "") ? (planDetails?.amcId ?? "")?.toLowerCase() : (planDetails?.amcId ?? "");

    return (
        <>
            <BreadCrum array={![USER_ROLES.INVESTOR].includes(role) ? rmRouterPath : investorRouterPath} />
            <Formik
                validationSchema={validationSchema(role, selectedPortfolioObj)}
                initialValues={initialValues}
                onSubmit={handleCancelSipBtn}
            >
                {({ values }) => {
                    console.log('values', values);
                    return (
                        <>
                            <Form>
                                <Box sx={{ marginTop: "25px" }}>
                                    <Typography
                                        variant="h1"
                                        sx={(theme: Theme) => ({
                                            lineHeight: "32.5px",
                                            color: theme.palette.text.primary
                                        })}
                                    >
                                        Reason for cancellation
                                    </Typography>
                                    <Box
                                        sx={{
                                            marginTop: "25px",
                                            display: "flex",
                                            flexWrap: "none",
                                            flexDirection: { xs: "column", lg: "row" },
                                            gap: "25px"
                                        }}
                                    >
                                        <Box
                                            sx={(theme: Theme) => ({
                                                flex: { xs: 1, lg: 2 },
                                                borderRadius: "20px",
                                                padding: "35px 30px",
                                                backgroundColor: theme.palette.common.white,
                                                boxShadow: `0px 4px 10px 0px ${theme.palette.common.black}0D`,
                                                display: "flex",
                                                flexDirection: "column",
                                                rowGap: "24px",
                                                ...((!isReasonsListLoading && reasonsList?.length === 0) ? {
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                } : {})
                                            })}
                                        >
                                            {isReasonsListLoading && (
                                                ([...Array(10)].map((_, index) => (
                                                    <Skeleton
                                                        key={index}
                                                        component="div"
                                                        variant="rounded"
                                                        sx={{
                                                            borderRadius: "10px",
                                                            padding: "32px",
                                                        }}
                                                    />
                                                )))
                                            )}
                                            {(!isReasonsListLoading && reasonsList?.length === 0) && (
                                                <Typography
                                                    variant="body_600"
                                                    sx={(theme: Theme) => ({
                                                        color: theme.palette.text.primary
                                                    })}
                                                >
                                                    No data found
                                                </Typography>
                                            )}
                                            {(!isReasonsListLoading && reasonsList?.length > 0) && (
                                                reasonsList?.map((obj: { code: string; description: string }) => (
                                                    <Box
                                                        key={obj.code}
                                                        sx={(theme: Theme) => ({
                                                            borderRadius: selectedReasonObj?.code === obj?.code ? "15px" : "10px",
                                                            backgroundColor: selectedReasonObj?.code === obj?.code ? `${theme.palette.primary[500]}1A` : theme.palette.common.white,
                                                            border: selectedReasonObj?.code === obj?.code ? `1px solid ${theme.palette.primary[500]}` : `0.5px solid ${theme.palette.text.secondary}80`,
                                                            padding: selectedReasonObj?.code === obj?.code ? "24px" : "24px 15px",
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            rowGap: "24px",
                                                            cursor: "pointer"
                                                        })}
                                                        onClick={() => handleReasonChange(obj?.code)}
                                                    >
                                                        <Box
                                                            sx={{
                                                                display: "flex",
                                                                alignItems: "center",
                                                                columnGap: "15px",
                                                            }}
                                                        >
                                                            <Radio
                                                                checked={selectedReasonObj?.code === obj?.code}
                                                                onChange={() => handleReasonChange(obj?.code)}
                                                                value={obj?.code}
                                                                name="cancellation-reason"
                                                                inputProps={{ 'aria-label': obj.description }}
                                                                sx={{
                                                                    padding: "0px",
                                                                    "& .MuiSvgIcon-root": {
                                                                        height: { xs: "15px", md: "18px", lg: "20px" },
                                                                        width: { xs: "15px", md: "18px", lg: "20px" },
                                                                    },
                                                                    "&:hover": {
                                                                        backgroundColor: "transparent"
                                                                    }
                                                                }}
                                                            />
                                                            <Typography
                                                                variant="body_500"
                                                                sx={(theme: Theme) => ({
                                                                    lineHeight: "20px",
                                                                    letterSpacing: "0.02px",
                                                                    color: selectedReasonObj?.code === obj.code ? theme.palette.primary[500] : theme.palette.text.primary
                                                                })}
                                                            >
                                                                {obj.description}
                                                            </Typography>
                                                        </Box>
                                                        {(
                                                            obj?.code === "13" &&
                                                            obj?.description?.toLowerCase()?.includes("others") &&
                                                            selectedReasonObj?.code === "13" &&
                                                            selectedReasonObj?.description?.toLowerCase()?.includes("others")
                                                        ) && (
                                                                <Box
                                                                    sx={{
                                                                        display: "flex",
                                                                        flexDirection: "column"
                                                                    }}
                                                                >
                                                                    <TextField
                                                                        id="others-reason"
                                                                        placeholder="Write reason"
                                                                        multiline
                                                                        minRows={6}
                                                                        sx={(theme: Theme) => ({
                                                                            "& .MuiInputBase-input::placeholder": {
                                                                                ...theme.typography.body_500,
                                                                                lineHeight: "20px",
                                                                                letterSpacing: "0.02px",
                                                                                color: theme.palette.text.secondary
                                                                            },
                                                                            "& .MuiOutlinedInput-notchedOutline": {
                                                                                borderRadius: "10px",
                                                                                border: `0.5px solid ${theme.palette.text.secondary}80`
                                                                            },
                                                                        })}
                                                                        onChange={handleOthersReasonChange}
                                                                    />
                                                                    <Typography
                                                                        variant="overline_600"
                                                                        sx={(theme: Theme) => ({
                                                                            color: theme.palette.grey[500],
                                                                            marginTop: "10px"
                                                                        })}
                                                                    >
                                                                        Minimum 1 character, maximum 200 characters allowed
                                                                    </Typography>
                                                                </Box>
                                                            )}
                                                    </Box>
                                                ))
                                            )}
                                        </Box>
                                        <Box sx={{
                                            flex: 1
                                        }}>
                                            {![USER_ROLES.INVESTOR].includes(role) &&
                                                MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                                                MPOWER_ACCOUNT_TYPE_MASTER["POA"]
                                                &&
                                                (
                                                    <Box
                                                        sx={(theme: Theme) => ({
                                                            background: theme.palette.background.paper,
                                                            padding: '20px',
                                                            borderRadius: '20px',
                                                            marginBottom: "20px",
                                                            display: "flex",
                                                            justifyContent: "center",
                                                            alignItems: "center",
                                                            flexDirection: "column"
                                                        })}
                                                        boxShadow={1}
                                                    >
                                                        <Typography
                                                            variant="body_500"
                                                            sx={(theme: Theme) => ({
                                                                lineHeight: "20px",
                                                                letterSpacing: "0.02px",
                                                                color: `${theme.palette.text.secondary}B2`,
                                                            })}
                                                        >
                                                            You can add minimum 1 attachment and maximum 5 attachments
                                                        </Typography>
                                                        <Typography
                                                            variant='body_400'
                                                            sx={(theme: Theme) => ({
                                                                color: theme.palette.text.primary,
                                                                alignSelf: "flex-start",
                                                                marginTop: "10px"
                                                            })}
                                                        >
                                                            Documents Uploaded: {
                                                                values?.documents?.filter((obj: {
                                                                    documentId: string;
                                                                    documentType: string;
                                                                }) => obj.documentId !== "" && obj.documentType !== "")?.length ?? "0"
                                                            }
                                                        </Typography>
                                                        <Button
                                                            sx={(theme: Theme) => ({
                                                                ...theme.typography.body_500,
                                                                color: theme.palette.primary[500],
                                                                padding: "5px",
                                                                fontWeight: 600,
                                                                marginTop: "15px"
                                                            })}
                                                            onClick={handleDocumentUploadDialogOpen}
                                                        // disabled={isLoading || apiLoading}
                                                        >
                                                            Upload Documents
                                                        </Button>
                                                    </Box>
                                                )
                                            }
                                            <Box
                                                sx={(theme: Theme) => ({
                                                    flex: 1,
                                                    borderRadius: "20px",
                                                    padding: "25px 30px 30px 30px",
                                                    backgroundColor: theme.palette.common.white,
                                                    boxShadow: `0px 4px 10px 0px ${theme.palette.common.black}0D`,
                                                    height: "fit-content"
                                                })}
                                            >
                                                {isUserDetailsLoading && (
                                                    <Box
                                                        sx={(theme: Theme) => ({
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            rowGap: "35px",
                                                            paddingBottom: "35px",
                                                            borderBottom: `0.5px solid ${theme.palette.text.secondary}B2`
                                                        })}
                                                    >
                                                        <Box
                                                            sx={{
                                                                display: "flex",
                                                                alignItems: "center",
                                                                columnGap: "15px"
                                                            }}
                                                        >
                                                            <Skeleton
                                                                component="div"
                                                                variant="rounded"
                                                                sx={{
                                                                    borderRadius: "50%",
                                                                    width: { xs: "45px", md: "50px", lg: "58px" },
                                                                    height: { xs: "45px", md: "50px", lg: "58px" },
                                                                }}
                                                            />
                                                            <Box
                                                                sx={{
                                                                    display: "flex",
                                                                    flexDirection: "column",
                                                                    rowGap: "5px",
                                                                    width: "100%"
                                                                }}
                                                            >
                                                                <Skeleton
                                                                    component="div"
                                                                    sx={(theme: Theme) => ({
                                                                        ...theme.typography.h2,
                                                                        width: "100%"
                                                                    })}
                                                                />
                                                                <Skeleton
                                                                    component="div"
                                                                    sx={(theme: Theme) => ({
                                                                        ...theme.typography.body_500,
                                                                        width: "50%"
                                                                    })}
                                                                />
                                                            </Box>
                                                        </Box>
                                                        <Box
                                                            sx={{
                                                                display: "flex",
                                                                flexDirection: "column",
                                                                rowGap: "12px"
                                                            }}
                                                        >
                                                            <Box
                                                                sx={{
                                                                    display: "flex",
                                                                    columnGap: "11px",
                                                                    alignItems: "center"
                                                                }}
                                                            >
                                                                <EmailIcon />
                                                                <Skeleton
                                                                    component="div"
                                                                    sx={(theme: Theme) => ({
                                                                        ...theme.typography.body_500,
                                                                        width: "50%",
                                                                    })}
                                                                />
                                                            </Box>
                                                            <Box
                                                                sx={{
                                                                    display: "flex",
                                                                    columnGap: "11px",
                                                                    alignItems: "center"
                                                                }}
                                                            >
                                                                <Phoneicon />
                                                                <Skeleton
                                                                    component="div"
                                                                    sx={(theme: Theme) => ({
                                                                        ...theme.typography.body_500,
                                                                        width: "50%",
                                                                    })}
                                                                />
                                                            </Box>
                                                        </Box>
                                                    </Box>
                                                )}
                                                {!isUserDetailsLoading && (
                                                    <Box
                                                        sx={(theme: Theme) => ({
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            rowGap: "35px",
                                                            paddingBottom: "35px",
                                                            borderBottom: `0.5px solid ${theme.palette.text.secondary}B2`
                                                        })}
                                                    >
                                                        <Box
                                                            sx={{
                                                                display: "flex",
                                                                alignItems: "center",
                                                                columnGap: "15px"
                                                            }}
                                                        >
                                                            {/* <Avatar
                                                                sx={(theme: Theme) => ({
                                                                    backgroundColor: theme.palette.primary[50],
                                                                    width: { xs: "45px", md: "50px", lg: "58px" },
                                                                    height: { xs: "45px", md: "50px", lg: "58px" },
                                                                })}
                                                            >
                                                                <Typography
                                                                    variant="h3"
                                                                    sx={(theme: Theme) => ({
                                                                        lineHeight: "30px",
                                                                        letterSpacing: "0.02px",
                                                                        color: theme.palette.primary[500],
                                                                    })}
                                                                >
                                                                    {getAbbreviatedName(userDetails?.name ?? "")}
                                                                </Typography>
                                                            </Avatar> */}
                                                            {getAbbreviatedName(userDetails?.name ?? "")}
                                                            <Box
                                                                sx={{
                                                                    display: "flex",
                                                                    flexDirection: "column",
                                                                    rowGap: "5px"
                                                                }}
                                                            >
                                                                <Typography
                                                                    variant="h2"
                                                                    sx={(theme: Theme) => ({
                                                                        lineHeight: "25px",
                                                                        letterSpacing: "0.01px",
                                                                        color: theme.palette.text.primary,
                                                                        marginBottom: "5px"
                                                                    })}
                                                                >
                                                                    {userDetails?.name ?? "-"}
                                                                </Typography>
                                                                <Box
                                                                    sx={{
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        columnGap: "5px"
                                                                    }}
                                                                >
                                                                    <Typography
                                                                        variant='body_500'
                                                                        sx={(theme: Theme) => ({
                                                                            lineHeight: "20px",
                                                                            letterSpacing: "0.02px",
                                                                            color: theme.palette.text.primary,
                                                                            whiteSpace: "nowrap"
                                                                        })}
                                                                    >
                                                                        Client Code:
                                                                    </Typography>
                                                                    <Typography
                                                                        variant='body_500'
                                                                        sx={(theme: Theme) => ({
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            lineHeight: "20px",
                                                                            letterSpacing: "0.02px",
                                                                            color: theme.palette.text.secondary,
                                                                            wordBreak: "break-word",
                                                                            maxWidth: "100%",
                                                                        })}
                                                                    >
                                                                        {![USER_ROLES.INVESTOR].includes(role) ? (routerStateObj?.clientCode ?? "-") : (investorClientId ?? "-")}
                                                                    </Typography>
                                                                </Box>
                                                                <Box
                                                                    sx={{
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        gap: "5px",
                                                                        flexWrap: "wrap"
                                                                    }}
                                                                >
                                                                    {/* <Typography
                                                                        variant="body_500"
                                                                        sx={(theme: Theme) => ({
                                                                            lineHeight: "20px",
                                                                            letterSpacing: "0.02px",
                                                                            color: theme.palette.text.secondary,
                                                                            textTransform: "capitalize"
                                                                        })}
                                                                    >
                                                                        {userDetails?.applicationType}
                                                                    </Typography>
                                                                    <Box
                                                                        sx={{
                                                                            width: "3px",
                                                                            height: "3px",
                                                                            backgroundColor: "text.secondary",
                                                                            alignSelf: "center",
                                                                            borderRadius: "50%"
                                                                        }}
                                                                    /> */}
                                                                    <Typography
                                                                        variant="body_500"
                                                                        sx={(theme: Theme) => ({
                                                                            lineHeight: "20px",
                                                                            letterSpacing: "0.02px",
                                                                            color: theme.palette.text.secondary
                                                                        })}
                                                                    >
                                                                        {selectedPortfolio?.label ?? ""}
                                                                    </Typography>
                                                                    <Box
                                                                        sx={{
                                                                            width: "3px",
                                                                            height: "3px",
                                                                            backgroundColor: "text.secondary",
                                                                            alignSelf: "center",
                                                                            borderRadius: "50%"
                                                                        }}
                                                                    />
                                                                    <Typography
                                                                        variant="body_500"
                                                                        sx={(theme: Theme) => ({
                                                                            lineHeight: "20px",
                                                                            letterSpacing: "0.02px",
                                                                            color: theme.palette.text.secondary
                                                                        })}
                                                                    >
                                                                        {userDetails?.accountType ?? ""}
                                                                    </Typography>
                                                                    <Box
                                                                        sx={{
                                                                            width: "3px",
                                                                            height: "3px",
                                                                            backgroundColor: "text.secondary",
                                                                            alignSelf: "center",
                                                                            borderRadius: "50%"
                                                                        }}
                                                                    />
                                                                    <Typography
                                                                        variant="body_500"
                                                                        sx={(theme: Theme) => ({
                                                                            lineHeight: "20px",
                                                                            letterSpacing: "0.02px",
                                                                            color: theme.palette.text.secondary,
                                                                            textTransform: "capitalize"
                                                                        })}
                                                                    >
                                                                        {userDetails?.modeOfHolding ?? ""}
                                                                    </Typography>
                                                                    <Box
                                                                        sx={{
                                                                            width: "3px",
                                                                            height: "3px",
                                                                            backgroundColor: "text.secondary",
                                                                            alignSelf: "center",
                                                                            borderRadius: "50%"
                                                                        }}
                                                                    />
                                                                    <Typography
                                                                        variant="body_500"
                                                                        sx={(theme: Theme) => ({
                                                                            lineHeight: "20px",
                                                                            letterSpacing: "0.02px",
                                                                            color: theme.palette.text.secondary
                                                                        })}
                                                                    >
                                                                        {/* {
                                                                            userDetails?.status ?
                                                                                applicantStatusMasters[userDetails.status] ?
                                                                                    applicantStatusMasters[userDetails.status] : userDetails.status
                                                                                : "N/A"
                                                                        } */}
                                                                        {userDetails?.investorType ?? ""}
                                                                    </Typography>
                                                                    {(`${userDetails?.isFamilyHead ?? ""}`.toLowerCase() === "y") && (
                                                                        <>
                                                                            <Box
                                                                                sx={{
                                                                                    width: "3px",
                                                                                    height: "3px",
                                                                                    backgroundColor: "text.secondary",
                                                                                    alignSelf: "center",
                                                                                    borderRadius: "50%"
                                                                                }}
                                                                            />
                                                                            <Typography
                                                                                variant="body_500"
                                                                                sx={(theme: Theme) => ({
                                                                                    lineHeight: "20px",
                                                                                    letterSpacing: "0.02px",
                                                                                    color: theme.palette.text.secondary
                                                                                })}
                                                                            >
                                                                                Head Of Family
                                                                            </Typography>
                                                                        </>
                                                                    )}
                                                                </Box>
                                                            </Box>
                                                        </Box>
                                                        <Box
                                                            sx={{
                                                                display: "flex",
                                                                flexDirection: "column",
                                                                rowGap: "12px"
                                                            }}
                                                        >
                                                            <Box
                                                                sx={{
                                                                    display: "flex",
                                                                    columnGap: "11px",
                                                                    alignItems: "center"
                                                                }}
                                                            >
                                                                <EmailIcon />
                                                                <Typography
                                                                    variant="body_500"
                                                                    sx={(theme: Theme) => ({
                                                                        lineHeight: "20px",
                                                                        letterSpacing: "0.02px",
                                                                        color: theme.palette.text.primary
                                                                    })}
                                                                >
                                                                    {userDetails?.email ?? "-"}
                                                                </Typography>
                                                            </Box>
                                                            <Box
                                                                sx={{
                                                                    display: "flex",
                                                                    columnGap: "11px",
                                                                    alignItems: "center"
                                                                }}
                                                            >
                                                                <Phoneicon />
                                                                <Typography
                                                                    variant="body_500"
                                                                    sx={(theme: Theme) => ({
                                                                        lineHeight: "20px",
                                                                        letterSpacing: "0.02px",
                                                                        color: theme.palette.text.primary
                                                                    })}
                                                                >
                                                                    {userDetails?.mobile ?? "-"}
                                                                </Typography>
                                                            </Box>
                                                        </Box>
                                                    </Box>
                                                )}
                                                <Box
                                                    sx={{
                                                        paddingTop: "35px",
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        rowGap: "35px"
                                                    }}
                                                >
                                                    {isPlanDetailsLoading && (
                                                        <Box
                                                            sx={{
                                                                display: "flex",
                                                                columnGap: "15px",
                                                                alignItems: "flex-start"
                                                            }}
                                                        >
                                                            <Skeleton
                                                                component="div"
                                                                variant="rounded"
                                                                sx={{
                                                                    borderRadius: "50%",
                                                                    width: { xs: "40px", md: "45px", lg: "50px" },
                                                                    height: { xs: "40px", md: "45px", lg: "50px" },
                                                                }}
                                                            />
                                                            <Box
                                                                sx={{
                                                                    flex: 1,
                                                                    display: "flex",
                                                                    flexDirection: "column",
                                                                    rowGap: "7px"
                                                                }}
                                                            >
                                                                <Skeleton
                                                                    component="div"
                                                                    sx={(theme: Theme) => ({
                                                                        ...theme.typography.body_600,
                                                                        width: "80%"
                                                                    })}
                                                                />
                                                                <Box
                                                                    sx={{
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        columnGap: "8px"
                                                                    }}
                                                                >
                                                                    <Skeleton
                                                                        component="div"
                                                                        sx={(theme: Theme) => ({
                                                                            ...theme.typography.body_500,
                                                                            width: "100%"
                                                                        })}
                                                                    />
                                                                    <Box
                                                                        sx={{
                                                                            display: 'flex',
                                                                            justifyContent: 'center',
                                                                            alignItems: 'center',
                                                                        }}
                                                                    >
                                                                        <Skeleton
                                                                            component="div"
                                                                            variant="rounded"
                                                                            sx={{
                                                                                borderRadius: "50%",
                                                                                width: "3px",
                                                                                height: "3px",
                                                                            }}
                                                                        />
                                                                    </Box>
                                                                    <Skeleton
                                                                        component="div"
                                                                        sx={(theme: Theme) => ({
                                                                            ...theme.typography.body_500,
                                                                            width: "100%"
                                                                        })}
                                                                    />
                                                                    <Box
                                                                        sx={{
                                                                            display: 'flex',
                                                                            justifyContent: 'center',
                                                                            alignItems: 'center',
                                                                        }}
                                                                    >
                                                                        <Skeleton
                                                                            component="div"
                                                                            variant="rounded"
                                                                            sx={{
                                                                                borderRadius: "50%",
                                                                                width: "3px",
                                                                                height: "3px",
                                                                            }}
                                                                        />
                                                                    </Box>
                                                                    <Skeleton
                                                                        component="div"
                                                                        sx={(theme: Theme) => ({
                                                                            ...theme.typography.body_500,
                                                                            width: "100%"
                                                                        })}
                                                                    />
                                                                </Box>
                                                            </Box>
                                                        </Box>
                                                    )}
                                                    {!isPlanDetailsLoading && (
                                                        <Box
                                                            sx={{
                                                                display: "flex",
                                                                columnGap: "15px",
                                                                // alignItems: "flex-start"
                                                                alignItems: "center"
                                                            }}
                                                        >
                                                            <Box
                                                                sx={{
                                                                    borderRadius: "50%",
                                                                    overflow: "hidden",
                                                                    width: "50px",
                                                                    height: "50px",
                                                                    flexShrink: 0,
                                                                }}
                                                            >
                                                                <Box
                                                                    component='img'
                                                                    src={checkImageExists(`${checkAmcId}`) ? `/images/amcIcons/${checkAmcId}.svg` : `/images/amcIcons/default.svg`}
                                                                    alt={planDetails?.planName ?? ""}
                                                                    sx={{
                                                                        width: "100%",
                                                                        height: "100%",
                                                                        objectFit: "contain",
                                                                        flexShrink: 0,
                                                                    }}
                                                                />
                                                            </Box>
                                                            <Box
                                                                sx={{
                                                                    flex: 1,
                                                                    display: "flex",
                                                                    flexDirection: "column",
                                                                    rowGap: "7px"
                                                                }}
                                                            >
                                                                <Typography
                                                                    variant="body_600"
                                                                    sx={(theme: Theme) => ({
                                                                        lineHeight: "22.5px",
                                                                        letterSpacing: "0.02px",
                                                                        color: theme.palette.text.primary
                                                                    })}
                                                                >
                                                                    {planDetails?.planName ?? ""}
                                                                </Typography>
                                                                {/* <Box
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                columnGap: "8px"
                                            }}
                                        >
                                            <Typography
                                                variant="body_500"
                                                sx={(theme: Theme) => ({
                                                    lineHeight: "20px",
                                                    letterSpacing: "0.02px",
                                                    color: theme.palette.text.secondary,
                                                    wordBreak: "break-all"
                                                })}
                                            >
                                                {planDetails?.fundCategory ?? ""}
                                            </Typography>
                                            {(planDetails?.fundTypeCategory ?? "") && (
                                                <>
                                                    <SeparatorCircle />
                                                    <Typography
                                                        variant="body_500"
                                                        sx={(theme: Theme) => ({
                                                            lineHeight: "20px",
                                                            letterSpacing: "0.02px",
                                                            color: theme.palette.text.secondary,
                                                            wordBreak: "break-all"
                                                        })}
                                                    >
                                                        {planDetails?.fundTypeCategory ?? ""}
                                                    </Typography>
                                                </>
                                            )}
                                            {(planDetails?.riskType ?? "") && (
                                                <>
                                                    <SeparatorCircle />
                                                    <Typography
                                                        variant="body_500"
                                                        sx={(theme: Theme) => ({
                                                            lineHeight: "20px",
                                                            letterSpacing: "0.02px",
                                                            color: theme.palette.text.secondary,
                                                            wordBreak: "break-all"
                                                        })}
                                                    >
                                                        {planDetails?.riskType ?? ""}
                                                    </Typography>
                                                </>
                                            )}
                                        </Box> */}
                                                            </Box>
                                                        </Box>
                                                    )}
                                                    <LoadingButton
                                                        fullWidth
                                                        loadingPosition="start"
                                                        variant="contained"
                                                        type="submit"
                                                        // onClick={handleCancelSipBtn}
                                                        sx={(theme: Theme) => ({
                                                            ...theme.typography.body_700,
                                                            lineHeight: "22.5px",
                                                            letterSpacing: "0.02px",
                                                            color: theme.palette.textDark.primary,
                                                            backgroundColor: theme.palette.primary[500],
                                                            borderRadius: "10px",
                                                            padding: "15px",
                                                        })}
                                                        // disabled={
                                                        //     !validateSelectedReasonObj(selectedReasonObj) ||
                                                        //     isReasonsListLoading
                                                        // }
                                                        disabled={
                                                            isReasonsListLoading
                                                        }
                                                    >
                                                        {`Cancel ${routerStateObj?.currentType?.toUpperCase()}`}
                                                    </LoadingButton>
                                                </Box>
                                            </Box>
                                        </Box>
                                    </Box>

                                </Box >
                            </Form>
                            <TransactionsDocumentUpload
                                open={isDocumentUploadDialogVisible}
                                onClose={handleDocumentUploadDialogClose}
                            />
                        </>
                    )
                }}
            </Formik>
            {/* Cancel SIP Confirmation Dialog */}
            <ConfirmationDialog
                open={isConfirmationDialogOpen}
                onCancel={handleCancelBtnConfirmationDialog}
                onConfirm={handleConfirmBtnConfirmationDialog}
                isLoading={isCancelResponseLoading || otpLoading}
            />
            {/* Cancel SIP Success Dialog */}
            <SuccessDialog
                open={isSuccessDialogOpen}
                handleClick={handleBtnSuccessDialog}
                content={cancelResponse?.message ?? ""}
            />
            {/* Cancel SIP Error Dialog */}
            <ErrorDialog
                open={isErrorDialogOpen}
                content={cancelResponse?.message ?? ""}
                handleClick={handleBtnErrorDialog}
            />

            {/* Document Upload Error Dialog Start */}
            <Dialog
                aria-labelledby="error-dialog"
                open={isDocumentUploadErrorDialogVisible}
                PaperProps={{
                    sx: {
                        maxWidth: '550px',
                        width: "100%",
                        borderRadius: "12px",
                        padding: "24px",
                        backgroundColor: palette.common.white
                    },
                }}
            >
                <DialogContent
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        rowGap: "12px",
                        padding: "15px",
                        overflow: "hidden"
                    }}
                >
                    <FailureIcon width="35" height="35" />
                    <Typography
                        variant="h2"
                        sx={(theme: Theme) => ({
                            lineHeight: "25px",
                            letterSpacing: "0.01px",
                            color: theme.palette.text.primary
                        })}
                    >
                        Error!
                    </Typography>
                    <Typography
                        variant="subtitle_400"
                        sx={(theme: Theme) => ({
                            lineHeight: "22px",
                            letterSpacing: "0.02px",
                            color: theme.palette.text.secondary,
                            textAlign: "center",
                            paddingLeft: "10px",
                            paddingRight: "10px"
                        })}
                    >
                        Please upload minimum 1 document
                    </Typography>
                </DialogContent>
                <DialogActions
                    sx={{
                        padding: "0px",
                        marginTop: "40px",
                    }}
                >
                    <Button
                        fullWidth
                        variant="contained"
                        onClick={handleDocumentUploadErrorDialogClose}
                        sx={(theme: Theme) => ({
                            ...theme.typography.body_500,
                            fontWeight: 600,
                            lineHeight: "20px",
                            color: theme.palette.common.white,
                            borderRadius: "4px",
                            padding: "13px 20px",
                            backgroundColor: theme.palette.primary[500]
                        })}
                    >
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
            {/* Document Upload Error Dialog End */}
        </>
    )
}